'use client';

import { DAY } from '@revoke.cash/core/utils/time';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import type { ReactNode } from 'react';

// Note: the query persister stuff is based on wagmi (https://github.com/wevm/wagmi/blob/2748416561a2724b7ade6255f5b06a60fe537001/packages/react/src/client.ts)

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Persisted queries will be refetched every 24 hours
      gcTime: 1 * DAY,
      networkMode: 'offlineFirst',
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

if (typeof window !== 'undefined') {
  persistQueryClient({
    queryClient,
    persister: createAsyncStoragePersister({ key: 'cache', storage: window.localStorage }),
    dehydrateOptions: {
      // Note: adding a `persist` flag to a query key will instruct the
      // persister whether or not to persist the response of the query.
      shouldDehydrateQuery: (query) => query.gcTime !== 0 && (query.queryKey.at(-1) as any)?.persist,
    },
  });
}

interface Props {
  children: ReactNode;
}

export const QueryProvider = ({ children }: Props) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
